@if (schema && control) {
  <div class="py2 px3">
    <!-- Header -->
    <div class="flex justify-start pb2">
      <div class="flex flex-column col-12">
        <h1 class="h2 mb0 pb0">
          @if (schema && schema.properties?.[control]?.title !== undefined) {
            {{ schema.properties?.[control]?.title }}
          } @else {
            {{ control }}
          }
        </h1>

        @if (schema.properties?.[control]?.description) {
          <span class="pt1">
            {{ schema.properties?.[control]?.description }}
          </span>
        }

        @if (schema.properties?.[control]?._readme) {
          <sfo-admonition title="About" type="info" expanded>
            <p [innerHTML]="schema.properties?.[control]?._readme | markdown"></p>
          </sfo-admonition>
        }
      </div>
    </div>

    <!-- Body -->
    <div class="col-12">
      <sfo-dynamic-field
        [schema]="schema.properties?.[control]"
        [aFormControl]="aFormControl"
        [renderMode]="'simple'"
        [control]="control"
      ></sfo-dynamic-field>
    </div>
  </div>
} @else {
  <div class="mt4 col-6 mx-auto">
    <sfo-admonition type="info" title="Getting Started" expanded hideToggle>
      <p>Please select a category from the left to change the {{schema?.title}}.</p>
    </sfo-admonition>
  </div>
}
